import { render, staticRenderFns } from "./Postcard.vue?vue&type=template&id=b8e4f9e0&"
import script from "./Postcard.vue?vue&type=script&lang=js&"
export * from "./Postcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports